import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

const BillingCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-indigo-950 to-slate-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {/* Icon */}
        <div className="w-20 h-20 rounded-full bg-slate-700/50 flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-10 h-10 text-slate-400" />
        </div>

        {/* Message */}
        <h1 className="text-2xl font-bold text-white mb-3">
          Checkout Canceled
        </h1>
        <p className="text-slate-400 mb-8">
          No worries! You can upgrade anytime when you're ready.
        </p>

        {/* Actions */}
        <div className="space-y-3">
          <button
            onClick={() => navigate('/billing')}
            className="w-full py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-medium transition-colors flex items-center justify-center gap-2"
            data-testid="try-again-btn"
          >
            <RefreshCw className="w-5 h-5" />
            View Plans Again
          </button>
          
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full py-3 bg-slate-700 hover:bg-slate-600 text-white rounded-xl font-medium transition-colors flex items-center justify-center gap-2"
            data-testid="back-dashboard-btn"
          >
            <ArrowLeft className="w-5 h-5" />
            Back to Dashboard
          </button>
        </div>

        {/* Reassurance */}
        <p className="text-slate-500 text-sm mt-8">
          Your free account is still active with 5 activities per day.
        </p>
      </div>
    </div>
  );
};

export default BillingCancelPage;
